'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('@/utils');

exports.default = {
  name: 'system-item',
  props: {
    list: {
      type: Array
    },
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    index: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data() {
    return {
      defaultImg: require('../../static/images/system-icon.png'),
      timeFormat: _utils.timeFormat
    };
  },
  created: function created() {},

  methods: {
    onClickItem: function onClickItem(item) {
      this.$router.push({
        path: '/notice-announcement/system-detail',
        query: {
          mesNotifyId: item.mesNotifyId
        }
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//